import { convertISOToPhDate } from '~shared/lib/convert-date';

import type { AgentFormValues } from '../../model/schemas';
import type { ApplicationDataResponse } from '../../model/types';

export function recoverAgents(
  agents: ApplicationDataResponse['agents']
): AgentFormValues[] | undefined {
  if (!agents?.length) return undefined;

  return agents.map((agent) => ({
    uiId: agent.uiId,
    firstName: agent.firstName,
    middleName: agent.middleName,
    lastName: agent.lastName,
    birthDate: convertISOToPhDate(agent.birthDate),
    email: agent.email,
    mobilePhone: agent.mobilePhone,
    assignedPointsOfSales: agent.assignedPointsOfSales ?? [],
  }));
}
